import { resources } from "@constants/hardcoded-strings";
import { ButtonWithSpinner } from "@containers/common/button-with-spinner/button-with-spinner";
import { useModalContext } from "@context/use-modal-context";
import { ButtonTypes } from "@enums/button-types";
import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";
import { ModalTypes } from "@enums/modal-types";
import { WorkflowChangeRequest } from "@idw-types/data/workflow-change-request";
import { FormattedWorkflowDetailsConfiguration } from "@idw-types/data/workflow-details-configuration";
import { createWorkflowChangeRequestRequest } from "@requests/service-configuration";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import {
    clickWorkflowChangeRequestActionHandler
} from "@utils/change-request-modal-util/workflow-change-request-modal-util";
import { useState } from "react";
import { useDispatch } from "react-redux";


type WorkflowDetailsStartChangeRequestButtonProps = {
    changeRequestStatus: ChangeRequestStatusTypes,
    workflowDetailsConfiguration: FormattedWorkflowDetailsConfiguration;
    setWorkflowChangeRequest: (changeRequest: WorkflowChangeRequest) => void;
    additionalSetWorkflowChangeRequests: (changeRequests: Array<WorkflowChangeRequest>) => void;
}

export const WorkflowDetailsStartChangeRequestButton = (props: WorkflowDetailsStartChangeRequestButtonProps) => {
    const {
        changeRequestStatus,
        workflowDetailsConfiguration,
        setWorkflowChangeRequest,
        additionalSetWorkflowChangeRequests
    } = props;
    const [requestInProgress, setRequestInProgress] = useState(false);
    const dispatch = useDispatch();
    const modalContext = useModalContext();

    const createWorkflowDetailChangeRequest = async () => {
        const { data, error } = await createWorkflowChangeRequestRequest(workflowDetailsConfiguration.id);
        if (data?.changeRequest) {
            displaySuccessModal(
                dispatch,
                resources.requests.createWorkflowChangeRequest.success.title,
                resources.requests.createWorkflowChangeRequest.success.message
            );

            setWorkflowChangeRequest(data.changeRequest);
            additionalSetWorkflowChangeRequests([data.changeRequest]);
            return data.changeRequest;
        } else if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.createWorkflowChangeRequest.error.title,
                resources.requests.createWorkflowChangeRequest.error.message,
                error
            );
        }
        return null;
    };

    const onSubmitCreateWorkflowChangeRequest = async (onModalClose: () => void) => {
        setRequestInProgress(true);
        const response = await createWorkflowDetailChangeRequest();
        setRequestInProgress(false);
        if (response) {
            onModalClose();
        }
        return response;
    }

    const onClickCreateAModifyChangeRequest = async () => {
        return clickWorkflowChangeRequestActionHandler(
            onSubmitCreateWorkflowChangeRequest,
            modalContext,
            workflowDetailsConfiguration.name,
            workflowDetailsConfiguration.id,
            changeRequestStatus,
            ModalTypes.CreateWorkflowChangeRequest
        );
    };

    return (
        <ButtonWithSpinner
            id="service-modal-start-request-change-button"
            variant={"primary"}
            disabled={requestInProgress}
            type={ButtonTypes.BUTTON}
            label={resources.common.dropdownItems.createModifyChangeRequest.label}
            onClick={onClickCreateAModifyChangeRequest} />
    );

}